import { createContext, useContext } from 'react'
import type { DeveloperPlatformOrgSource } from '@mysaiva/core/developer-platform'

/**
 * Product whose org list backs the workspace, resolved once from the user's
 * `product_list` by `DeveloperPlatformProviders`.
 */
export const WorkspaceOrgSourceContext = createContext<DeveloperPlatformOrgSource | null>(null)

export function useWorkspaceOrgSource(): DeveloperPlatformOrgSource {
  const product = useContext(WorkspaceOrgSourceContext)
  if (!product) {
    throw new Error('useWorkspaceOrgSource must be used inside DeveloperPlatformProviders')
  }
  return product
}
